import React, { useState, useEffect } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText, CircularProgress } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { useParams } from 'react-router-dom';
import { fetchSingleEmployee, updateEmployeeEntry } from '../../Store/PHPSlice/Employee';
import { selectlocationdata } from '../Selectors/Master/ItemSelectors';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchTeamLeader } from '../../Store/PHPSlice/TeamLeader/TeamLeader';
import { selectTeamLeaderReg } from '../Selectors/Master/OutwardSelectors';



const EmployeeEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        empId: parseInt(Id),
        empName: '',
        ph: '',
        emailId: '',
        category: '',
        departId: '',
        payType: '',
        amt: '',
        teamleader: 0,
        team_sts: '',
        tname: '',
        punchId: 0,
        adrs: '',
        gstNo:'',
        panNo:'',
        userId: userdata?.ID,
        locId: ''
    });
    const [multipleData, setMultipleData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [departlist, setDepartlist] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [errors, setErrors] = useState({});
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const dispatch = useDispatch();
    const department = useSelector((state) => state.DepartmentData.department || { data: [] });
    const singleEmployee = useSelector((state) => state.EmployeeData.singleEmployee || { data: [] });
    const loclist = useSelector(selectlocationdata);

    const teamleaderdata = useSelector(selectTeamLeaderReg);

    useEffect(() => {
        dispatch(fetchDepartmentData());
        dispatch(fetchSingleEmployee(Id));
        dispatch(fetchLocationData());
        dispatch(fetchTeamLeader());
    }, [dispatch]);

    useEffect(() => {
        if (formData.category === '1') {
            const filterDepart = department?.data?.filter(
                (item) => item.departNm !== 'CUT-TO-PACK' && item.departNm !== 'STITCH-TO-PACK'
            ) || []; // Fallback to empty array if undefined
            setDepartlist(filterDepart);
        } else {
            setDepartlist(department?.data || []); // Fallback to empty array if undefined
        }
    }, [formData.category]);

    useEffect(() => {
        if (singleEmployee?.data) {
            const item = singleEmployee?.data;
            setFormData({
                ...formData,
                empName: item.empNm,
                ph: item.contact,
                emailId: item.emailId,
                payType: item.payType,
                amt: item.payAmt,
                teamleader: item.teamleader,
                team_sts: item.team_sts,
                tname: item.teamId,
                locId: item.locId,
                adrs: item.adrs,
                punchId: item.punchId,
                gstNo:item.gstNo,
                panNo:item.panNo,
                // locId: item?.locId
            });

            setMultipleData(singleEmployee?.info);
        }
    }, [singleEmployee]);

    if (!department && !singleEmployee) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle numerical inputs for contactNo and accNo
        if (name === 'ph' || name === 'amt') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'ph' && value.length > 10) {
            return;
        }

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const PaymentType = [
        { label: 'Weekly', value: 1 },
        { label: 'Monthly', value: 2 },
        { label: 'On-Work', value: 3 }
    ]

    const teamLeader = [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 }
    ];

    const Categorylist = [
        { label: 'In-House', value: '1' },
        { label: 'Contractor', value: '2' },
        { label: 'Fixed Employee', value: '3' },
    ];

    // console.log(singleEmployee)
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const dropdownDepartment = [
        {
            label: 'Department',
            id: 'departId',
            options: department?.data || [],
            value: formData.departId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'departId', value: newValue ? newValue.ID : '' } }, 'departId'),
            getOptionLabel: (option) => option.departNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },

            errors: errors.departId
        },
        // {
        //     label: 'Firm',
        //     id: 'firmId',
        //     options: firmlist?.data || [],
        //     value: formData.firmId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
        //     getOptionLabel: (option) => option.firmNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // },

        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },

        }
    ];
    // { label: 'Punching Id', name: 'punchId' }


    const handleAddDepartment = () => {
        if (formData.category === '') {
            alert('select Category');
        } else if (formData.departId === '') {
            alert('select Department');
        } else {
            const selectCategory = Categorylist?.find(
                item => item.value === formData.category
            );

            const selectDepart = departlist?.find(
                item => item.ID === formData.departId
            );

            // Safety check
            if (!selectCategory || !selectDepart) {
                alert('Please select both Category and Department');
                return;
            }

            const data = {
                categoryNm: selectCategory.label,
                category: selectCategory.value,
                departId: selectDepart.ID,
                departNm: selectDepart.departNm
            };

            const exist = multipleData?.some(
                item =>
                    item.category === data.category &&
                    item.departId === data.departId
            );

            if (exist) {
                alert('This Category and Department already exist');
                return;
            }

            setMultipleData(prev => [...prev, data]);
            setFormData(prev => ({
                ...prev,
                departId: '',
                category: ""
            }));
        }

    };


    const handleCheckboxChange = (event, index) => {
        const updatedSelectedItems = [...selectedItems];
        if (event.target.checked) {
            updatedSelectedItems.push(index); // Add to selected items
        } else {
            // Remove from selected items
            const itemIndex = updatedSelectedItems.indexOf(index);
            if (itemIndex > -1) {
                updatedSelectedItems.splice(itemIndex, 1);
            }
        }
        setSelectedItems(updatedSelectedItems);
    };

    // Handle remove function
    const handleRemove = () => {
        const filteredData = multipleData.filter((_, index) => !selectedItems.includes(index));
        // Perform your data update logic here (e.g., set state or make API call)
        // console.log("Updated data after removal: ", filteredData);

        const deleteData = multipleData.filter((_, index) => selectedItems.includes(index));
        setMultipleData(filteredData);
        setDeletedItems(deleteData);
    };



    const validate = () => {
        const newErrors = {};
        if (!formData.empName) newErrors.empName = 'Employee Name is required';
        if (!formData.emailId) newErrors.emailId = 'Email is required';
        if (!formData.ph) {
            newErrors.ph = 'Contact is required';
        } else if (!/^\d{10}$/.test(formData.ph)) {
            newErrors.ph = 'Contact must be a 10-digit number';
        }
        // if (!formData.departId) newErrors.departId = 'Department Name is required';

        return newErrors;
    };

    const postObj = (formData, multipleData, deletedItems) => {
        const data =
        {
            empId: formData.empId,
            empName: formData.empName,
            ph: formData.ph,
            emailId: formData.emailId,
            payType: formData.payType,
            teamleader: formData.teamleader,
            amt: formData.amt,
            userId: formData.userId,
            multipleData: multipleData,
            deletedItems: deletedItems,
            teamNm: formData.tname,
            locId: formData.locId,
            adrs: formData.adrs,
            punchId: formData.punchId,
            panNo:formData.panNo,
            gstNo:formData.gstNo,
        };
        return data;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);

        try {
            const postObjs = postObj(formData, multipleData, deletedItems);
            // console.log(postObjs);
            const result = await dispatch(updateEmployeeEntry(postObjs)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Employee Updated Successful");
            alert("Employee Updated Successful");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }
    };

    const dropdownTeamLeader = [
        {
            label: 'Team Leader Name',
            id: 'tname',
            options: teamleaderdata?.data || [],
            value: formData.tname,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'tname', value: newValue ? newValue.ID : '' } }, 'tname'),
            getOptionLabel: (option) => option.teamLeaderNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
    ];
    // console.log(formData)
    return (
        <>
            <div style={{ margin: '1%' }}>
                <h2>Employee Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>
                                {[
                                    { label: 'Employee Name', name: 'empName' },
                                    { label: 'Contact', name: 'ph' },
                                    { label: 'Address', name: 'adrs' },
                                    { label: 'Email', name: 'emailId' },
                                    { label: 'Punching Id', name: 'punchId' },
                                    { label: 'Amount', name: 'amt' },
                                    { label: 'GST No', name: 'gstNo' },
                                    { label: 'PAN No', name: 'panNo' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="payType">Payment Type :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Select
                                                    labelId="payType"
                                                    id="payType"
                                                    name="payType"
                                                    value={formData.payType}
                                                    onChange={(e) => handleDropdownChange(e, 'payType')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        PaymentType.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="category">Category :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.payType}>
                                                <Select
                                                    labelId="category"
                                                    id="category"
                                                    name="category"
                                                    value={formData.category}
                                                    onChange={(e) => handleDropdownChange(e, 'category')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        Categorylist?.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                {errors.category && <FormHelperText style={errorStyles}>{errors.category}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {dropdownDepartment?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                        errors={drop.errors}
                                    />
                                ))
                                }


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="teamleader">Team Leader :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Select
                                                    labelId="teamleader"
                                                    id="teamleader"
                                                    name="teamleader"
                                                    value={formData.teamleader}
                                                    onChange={(e) => handleDropdownChange(e, 'teamleader')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        teamLeader.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {
                                    formData.teamleader == 1 &&
                                    dropdownTeamLeader?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}
                                        />
                                    ))

                                }


                                <Grid item xs={12} md={6}>
                                    <Button variant="contained" color="primary" onClick={handleAddDepartment}
                                        disabled={formData.category === '' && formData.departId === ''}
                                    >Add</Button>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Button variant="contained" color="primary" onClick={handleRemove}
                                        disabled={selectedItems.length === 0}>Delete</Button>
                                </Grid>

                                <table>
                                    <thead>
                                        <th>Sr.No.</th>
                                        <th>Category</th>
                                        <th>Department</th>

                                    </thead>
                                    <tbody>
                                        {multipleData?.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedItems.includes(index)}
                                                        onChange={(e) => handleCheckboxChange(e, index)}
                                                    />{" "}
                                                    {index + 1}</td>
                                                <td>{item.categoryNm}</td>
                                                <td>{item.departNm}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default EmployeeEdit;